/* src/app/views/not-found/not-found.component.scss */
.not-found-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 6em;
  text-align: center;
}
.not-found-container .mt-2 {
  margin-top: 30px;
}
/*# sourceMappingURL=not-found.component-HIEUPHRD.css.map */
